import { render, staticRenderFns } from "./chart copy 2.vue?vue&type=template&id=6d7634a1&scoped=true&"
import script from "./chart copy 2.vue?vue&type=script&lang=js&"
export * from "./chart copy 2.vue?vue&type=script&lang=js&"
import style0 from "./chart copy 2.vue?vue&type=style&index=0&id=6d7634a1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7634a1",
  null
  
)

export default component.exports